import { Address } from "./address";
import { CustomField } from "projects/core/src/include/structures";

export class Project{
    id:number;
    name:string;
    code:string;
    description:string;
    addressItem:Address;
    id_address:number;
    id_type:number;
    date:string;
    date_end:string;
    amount:number;
    cost:number;
    paid:number;
    note:string;
    phase:number;
    files:File[];
    customfields:CustomField[];

}